import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from 'firebase/firestore'
import { getStorage } from "firebase/storage";

// const firebaseConfig = {
//   apiKey:"AIzaSyC2fNVzOBgcvW519rMV5HgCOjJ4kj2aLug",
//   authDomain: "nestease-dev.firebaseapp.com",
//   databaseURL: "nestease-dev",
//   projectId: "nestease-dev.appspot.com",
//   storageBucket: "867628520234",
//   messagingSenderId: "1:867628520234:web:952c5702aa0b36bcdb4453",
//   appId: "https://nestease-dev-default-rtdb.firebaseio.com"
// };

// const app = initializeApp(firebaseConfig);

const firebaseConfig = {
  apiKey: "AIzaSyCBx2WOFRNAEQG6KZhNTbn4pvZu9jQ7jQs",
  authDomain: "nestease-66d12.firebaseapp.com",
  databaseURL: "https://nestease-66d12.firebaseio.com",
  projectId: "nestease-66d12",
  storageBucket: "nestease-66d12.appspot.com",
  messagingSenderId: "32211886209",
  appId: "1:32211886209:web:21ccb00acac32860dbad80",
  measurementId: "G-DT1REH5RJ4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage };


